import { Button, Tag } from "antd";
import React from "react";
import { FlightOpenIcon } from "~/components/flight/FlightOpenIcon.jsx";
import { $t } from "~/i18n.js";
import { _parseDate } from "~/lib/localize.js";
import { PaymentTag } from "./PaymentTag.jsx";
import { RenderLedgerAmount } from "./RenderLedgerAmount.jsx";
import { ImportStatus } from "./importStatus.jsx";
import { VerwijderButtonConfirm } from "~/components/buttons/VerwijderButtonConfirm.jsx";

export function LedgerColumns({ cancelDirectDebit, onEdit, hasUsers, ledgerImportStatus, readOnly }) {
  
  return [
    {
      title: $t("Datum"),
      dataIndex: "date_posting",
      render: (value) => _parseDate(value),
    },
    hasUsers
      ? {
          title: $t("Type"),
          render: (_, record) => {
            if (record.flight_id) return <Tag>{$t("Vlucht")}</Tag>;
            if (record.voucher_id) return <Tag>{$t("Bon")}</Tag>;
            if (record.payment_status) return <Tag>{$t("Betaling")}</Tag>;
            if (record.is_custom) return <Tag>{$t("Handmatig")}</Tag>;
            if (record.is_bank) return <Tag>{$t("Bankafschrift")}</Tag>;
          },
        }
      : null,

    hasUsers
      ? {
          title: $t("Gebruiker"),
          render: (_, record) => (
            <p className="row" style={{ gap: 12 }}>
              <span>{record.user?.name}</span>
              <span>{record.voucher?.name}</span>
            </p>
          ),
        }
      : null,
    {
      title: $t("Omschrijving"),
      dataIndex: "name",
      render: (value, record) => (
        <div>
          {value}

          {record.flight_id && (
            <FlightOpenIcon flight_uuid={record.flight_id} />
          )}
        </div>
      ),
    },
    {
      title: $t("Betaling"),
      render: (value, record) => (
        <div>
          {record.error && (
            <Tag color="red" style={{ marginRight: 8 }}>
              {$t("Data fout")}
            </Tag>
          )}
          {record.payment_status && (
            <PaymentTag status={record.payment_status} isDirectDebit={record.is_directdebit} />
          )}
        </div>
      ),
    },
    {
      title: <div style={{ marginRight: 6 }}>{$t("Bedrag")}</div>,
      dataIndex: "amount",
      align: "right",
      render: (_, record) => <RenderLedgerAmount ledger={record} />,
    },
    onEdit && !readOnly && {
      render: (_, record) => (
        <div className="row" style={{gap: 6}}>
          {!record.payment_status && (
          <Button size="small" onClick={() => onEdit(record)}>
            {$t("Bewerken")}
          </Button>
        )}
        {cancelDirectDebit && record.payment_status === 'scheduled' && record.is_directdebit && (
          <VerwijderButtonConfirm buttontext={$t('Annuleer')} size='small' onConfirm={() => cancelDirectDebit(record)} />
        )}
        </div>
      )
    },

    ImportStatus({importStatus: ledgerImportStatus})
  ].filter((f) => f);
}
